import { createSlice } from '@reduxjs/toolkit';
import {
  fetchHolidays,
  createHoliday,
  updateHoliday,
  deleteHoliday,
} from '../thunks/holidayThunks';

const initialState = {
  holidays: [],
  loading: false,
  error: null,
  total: 0,
  currentPage: 1,
  limit: 10,
};

const holidaysSlice = createSlice({
  name: 'holidays',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Holidays
      .addCase(fetchHolidays.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHolidays.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays = action.payload?.data?.holidays || [];
        state.total = action.payload?.data?.pagination?.total || 1;
        state.currentPage = action.payload?.data?.pagination?.page || 1;
        state.limit = action.payload?.data?.pagination?.limit || 10;
      })
      .addCase(fetchHolidays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Holiday
      .addCase(createHoliday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createHoliday.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays.unshift(action.payload?.data?.holiday);
      })
      .addCase(createHoliday.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Holiday
      .addCase(updateHoliday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHoliday.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.holidays.findIndex(h => h._id === action.payload?.data?.holiday._id);
        if (index !== -1) {
          state.holidays[index] = action.payload?.data?.holiday;
        }
      })
      .addCase(updateHoliday.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Holiday
      .addCase(deleteHoliday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteHoliday.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays = state.holidays.filter(h => h._id !== action.payload?.data?.holiday._id);
      })
      .addCase(deleteHoliday.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default holidaysSlice.reducer; 